import NoDataTwoTone from '@pf-ui/pf-icons-react/NoDataTwoTone';
import * as React from 'react';
const Simple = () => React.createElement(NoDataTwoTone, null);
export default Simple;
